<template>
    <div class="m-pdf">
        <van-nav-bar safe-area-inset-top  left-arrow    @click-left="$router.go(-1)"   /> 
      <div id="pdf-content" style="width: 100%;height: 100%;"></div>
    </div>
  </template>
  <script>
  import Pdfh5 from 'pdfh5'
  import 'pdfh5/css/pdfh5.css'
  export default {
    name: 'Pdfh5',
    data () {
      return {
        pdfh5: null,
      }
    },
    mounted () {
      // pdfh5实例化时传两个参数：selector选择器，options配置项参数，会返回一个pdfh5实例对象，可以用来操作pdf，监听相关事件
      // pdfh5 = new Pdfh5(selector, options) goto初始到第几页，logo设置每一页pdf上的水印
    //   this.pdfh5 = new Pdfh5('#pdf', { pdfurl: this.pdfUrl, goto: 1, logo: { src: require('../../assets/image/delete.png"'), x: 420, y: 700, width: 120, height: 120 } })
    //   // 监听pdf准备开始渲染，此时可以拿到pdf总页数
    //   this.pdfh5.on('ready', function () {
    //     console.log('总页数:' + this.totalNum)
    //   })
    //   // 监听pdf加载完成事件，加载失败、渲染成功都会触发
    //   this.pdfh5.on('complete', (status, msg, time) => {
    //     console.log('状态:' + status + '，信息:' + msg + '，耗时:' + time + '毫秒')
    //   })
    this.initPdf(this.$route.query.pdfurl)
    },
    methods:{
        downloadPdf() {
          console.log("开始下载");
         this.pdfh5.download();
        },

        initPdf(pdfUrl) {
                console.log('子组件的地址', pdfUrl)
                // pdfh5实例化时传两个参数：selector选择器，options配置项参数，会返回一个pdfh5实例对象，可以操作pdf，监听相关事件
                this.pdfh5 = new Pdfh5('#pdf-content', {
                    pdfurl: pdfUrl
                })

                this.pdfh5.scrollEnable(true) // 允许pdf滚动
                // 监听pdf准备开始渲染，可以拿到pdf总页数
                this.pdfh5.on('ready', function() {
                    console.log('总页数:' + this.totalNum)
                })
                
                // 监听pdf加载完成事件
                this.pdfh5.on('complete', (status, msg, time) => {
                    console.log('状态:' + status + '，信息:' + msg + '，耗时:' + time + '毫秒')
                })
    },

    }
  }
  
  </script>
  <style lang="scss" scoped>  
  .m-pdf { // 保证pdf区域铺满整个屏幕
    // 方法1：使用vw和vh视窗单位，1vw=视窗宽度的1%；1vh=视窗高度的1%
     width: 100vw;
     height: 100vh;
    // 方法2：使用fixed定位
    
   
  }
  </style>